import api from '../../../lib/api';

export default {
  async getSales({ rootState, commit }, filters = {}) {
    const { year, month, day } = filters;

    const { companyId: company } = rootState.auth;

    const { payload, payloadNonFiscal } = await api.statistics.getSalesByCompany(
      company,
      year,
      month,
      day,
    );

    let accessor = '';
    let nonFiscalAccessor = '';

    if (year && month && day) {
      accessor = 'salesDay';
      nonFiscalAccessor = 'salesDayNonFiscal';
    } else if (year && month) {
      accessor = 'salesMonth';
      nonFiscalAccessor = 'salesMonthNonFiscal';
    } else if (year) {
      accessor = 'salesYear';
      nonFiscalAccessor = 'salesYearNonFiscal';
    } else {
      accessor = 'salesAll';
      nonFiscalAccessor = 'salesAllNonFiscal';
    }

    commit('setValue', { accessor, value: payload });
    commit('setValue', { accessor: nonFiscalAccessor, value: payloadNonFiscal });
  },

  async getItemSales({ rootState, commit }) {
    const { companyId: company } = rootState.auth;

    const payload = await api.statistics.getItemSalesByCompany(company);

    commit('setValue', { accessor: 'salesItems', value: payload });
  },

  async getAllItemSales({ rootState, commit }) {
    const { companyId: company } = rootState.auth;

    const payload = await api.statistics.getAllItemSalesByCompany(company);

    commit('setValue', { accessor: 'salesItemsAll', value: payload });
  },

  async getDebtsSummary({ commit }) {
    const payload = await api.balances.getDebtsSummary();

    commit('setValues', payload);
  },

  getBanner: (rootState, position) => api.invoice.getBanner(position, 'dashboard'),
};
